/** Rolling number (cash counter): eases toward its target and snaps when close. Pure. */
export class RollingCounter {
  value: number;
  target: number;

  constructor(initial = 0) {
    this.value = initial;
    this.target = initial;
  }

  setTarget(t: number, snap = false): void {
    this.target = t;
    if (snap) this.value = t;
  }

  /** Advance by dt seconds; returns the whole-number display value. */
  update(dt: number): number {
    const gap = this.target - this.value;
    if (Math.abs(gap) < 0.5) {
      this.value = this.target;
    } else {
      // Exponential ease, but guarantee a minimum speed so small gaps don't crawl.
      const step = gap * (1 - Math.exp(-7 * dt));
      const minStep = Math.sign(gap) * Math.min(Math.abs(gap), 40 * dt);
      this.value += Math.abs(step) > Math.abs(minStep) ? step : minStep;
    }
    return Math.round(this.value);
  }

  get settled(): boolean {
    return this.value === this.target;
  }
}
